import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TextMessageResponse } from '../models/responses/text-message-response';
import { environment } from '../environments/environments';
import { TextMessageRequest } from '../models/requests/text-message-request';
import { TextConversationResponse } from '../models/responses/text-conversation-response';

@Injectable({
  providedIn: 'root'
})
export class TextMessageService {

  constructor(private httpClient: HttpClient) { }

  sendMessage(request: TextMessageRequest) {
    return this.httpClient.post<TextConversationResponse>(`${environment.textMessageUrl}/sendMessage`, request);
  }

  initConversation(aiAgentId: number) {
    return this.httpClient.post<TextConversationResponse>(`${environment.textMessageUrl}/init`, { aiAgentId: aiAgentId });
  }

}
